import { createApp } from 'vue';

import Bodegas from '../components/Bodegas.vue';
import Events from '../components/Events.vue';
import Educators from '../components/Educators.vue';
import Recipes from '../components/Recipes.vue';
import Cocktails from '../components/Cocktails.vue';
import Sherryspots from '../components/Sherryspots.vue';
import Sherryspotsuk from '../components/Sherryspotsuk.vue';
import Meetthemaker from '../components/Meetthemaker.vue';
import Sherrysession from '../components/Sherrysession.vue';
import Sherryweek from '../components/Sherryweek.vue';
import i18n from './i18n';


const mountEl = document.querySelector("#app");

if(mountEl){

  const formtype = mountEl.dataset.formtype;

  if(formtype){
    let app = false;
    if(formtype == 'Bodegas'){
      app = createApp(Bodegas,{ ...mountEl.dataset });
    }
    else if(formtype == 'Cocktails') {
     app = createApp(Cocktails,{ ...mountEl.dataset });
    }
    else if(formtype == 'Recipes') {
      app = createApp(Recipes,{ ...mountEl.dataset });
    }
    else if(formtype == 'Events') {
      app = createApp(Events,{ ...mountEl.dataset });
    }
    else if(formtype == 'Educator') {
      app = createApp(Educators,{ ...mountEl.dataset });}
    else if(formtype == 'Sherryspots') {
      app = createApp(Sherryspots,{ ...mountEl.dataset });
    }
    else if(formtype == 'Sherryspotsuk') {
      app = createApp(Sherryspotsuk,{ ...mountEl.dataset });
    }
    else if(formtype == 'Meetthemaker') {
      app = createApp(Meetthemaker,{ ...mountEl.dataset });
    }
    else if(formtype == 'Sherrysession') {
      app = createApp(Sherrysession,{ ...mountEl.dataset });
    }
     else if(formtype == 'Sherryweek') {
      app = createApp(Sherryweek,{ ...mountEl.dataset });
    }
    // app = createApp(Meetthemaker,{ ...mountEl.dataset });


    if(app){
      app.use(i18n);
      app.mount('#app');
    }
  }
}

window.document.addEventListener("DOMContentLoaded", function () {
  window.console.log("dom ready 2");
});

